import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiConfig, getApiUrl } from 'src/config/apiConfig';
import axiosIn from 'src/middlewares/axiosInterceptor';

const initialState: any = {
  fetchedTableData: {
    // TODO : Implemented also in appGeneralReducer. This is not in use. But tables require this.
    tabId_main: [],
  },
  currentTab: 'tabId_main',

  searchForm: {},

  actionButtonStates: { filter: { show: false, data: {} }, order: { show: false, data: {} }, plus: { show: false, data: {} } },
};

export const SubdomainsPageSlice: any = createSlice({
  name: 'SubdomainsPageSlice',
  initialState,
  reducers: {
    setCurrentTab: (state, action) => {
      state.currentTab = action.payload;
    },
    setSubdomainsSearchForm: (state, action) => {
      const { key, value } = action.payload;
      state.searchForm[key] = value;
    },
    setDataForTab: (state, action) => {
      const { tabId, res } = action.payload;
      state.fetchedTableData[tabId] = res;
    },
    targetsClearForm: (state) => {
      state.searchForm = {};
    },
  },
  extraReducers: (builder) => { },
});

export const {
  //
  setSubdomainsSearchForm,
  setCurrentTab,
  setDataForTab,
  targetsClearForm,
} = SubdomainsPageSlice.actions;

export default SubdomainsPageSlice.reducer;
